<!--<div class="fulfillmentLanding xs-mt-0 xs-mb-20">
  <div class="status-bar">
    <div><span class="font16 pr-2">Status Notice:</span><span>{{bannerMessage}}</span></div>
  </div>
</div>-->
<div class="fulfillmentLanding seed-return-wrapper">
  <div class="SOTLandingPage">
    <div class="row">
      <div class="col-md-10 col-lg-10 margin-l0 TopSec">
        <h3>
          Stock Transfers
          <span class="d-inline-block d-md-none" (click)="showText()"><i class="fas fa-regular fa-info-circle"></i></span>
        </h3>
        <p class="smalltext" *ngIf="isShow">
          Filter transfer requests by choosing the type of filter you`d like to use and searching for a value. You may opt to view your submitted requests on the tab below, or see your saved drafts by selecting transfer drafts tab.
        </p>
      </div>
    </div>

    <div class="row margin-md-b10">
      <div class="col-lg-11 col-md-9">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div class="col-lg-1 col-md-3 margin-t12 text-left d-none d-md-block">
        <button mat-raised-button class="btns xs-button xs-full-width export-button"
                [disabled]="(this.selectedTabIndex === 0 && this.sotRequestList && this.sotRequestList.length <= 0) || (this.selectedTabIndex === 1 && this.sotToRequestList && this.sotToRequestList.length <= 0) || (this.selectedTabIndex === 2 && this.sotRequestDraftList && this.sotRequestDraftList.length <= 0)" (click)="export()">
          Export
        </button>
      </div>
      <div class="col-12 d-block d-md-none margin-b10">
        <button mat-raised-button class="btns index-z200 wide100 height-md-44" color="primary" (click)="createNewOrder($event , selectedTabIndex)">New Stock Transfer</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">

        <mat-tab-group disableRipple [(selectedIndex)]="selectedTabIndex" [animationDuration]="'400ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">

          <mat-tab>
            <ng-template mat-tab-label>
              <i class="transferFromIcon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head" id="transferFromTab">
                <h4>
                  Transfer To
                </h4>
                <p class="subhead d-none d-md-block">
                  Receiving Dealer
                </p>
              </div>
            </ng-template>
            <div class="col-md-12 padding-0">
              <app-gridview [propHeaderDS]="headerList"
                            [propBodyDS]="sotRequestDataSource?.data"
                            (ActionPerformed)="OnActionPerform($event)"
                            (CreateClicked)="createNewOrder($event , selectedTabIndex)"
                            (UpdateClicked)="updateExistingOrder($event)"
                            [isReadOnlyAccess]="readOnlyAccess"
                            [isCreateButton]="true"
                            [CreateButtonTitle]="'New Stock Transfer'"
                            [isPaginatorRequired]="true">
              </app-gridview>
            </div>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <i class="transferFromIcon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head" id="transferToTab">
                <h4>
                  Transfer From
                </h4>
                <p class="subhead d-none d-md-block">
                  Sending Dealer
                </p>
              </div>
            </ng-template>

            <div class="col-md-12 padding-0">
              <app-gridview [propHeaderDS]="headerToList"
                            [propBodyDS]="sotToRequestDataSource?.data"
                            (ActionPerformed)="OnActionPerform($event)"
                            (CreateClicked)="createNewOrder($event , selectedTabIndex)"
                            (UpdateClicked)="updateExistingOrder($event)"
                            [isReadOnlyAccess]="readOnlyAccess"
                            [isCreateButton]="true"
                            [CreateButtonTitle]="'New Stock Transfer'"
                            [isPaginatorRequired]="true">
              </app-gridview>
            </div>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <i class="transferDraftIcon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head" id="transferDraftTab">
                <h4>
                  Transfer Draft
                </h4>
                <p class="subhead d-none d-md-block">
                  Draft stock transfers
                </p>
              </div>
            </ng-template>

            <div class="col-md-12 padding-0">
              <app-gridview [propHeaderDS]="headerListDraft"
                            [propBodyDS]="draftRequestDataSource?.data"
                            (ActionPerformed)="OnActionPerform($event)"
                            (CreateClicked)="createNewOrder($event , selectedTabIndex)"
                            [isReadOnlyAccess]="readOnlyAccess"
                            [isCreateButton]="true"
                            [CreateButtonTitle]="'New Stock Transfer'"
                            (UpdateClicked)="updateExistingOrder($event)"
                            [isPaginatorRequired]="true">
              </app-gridview>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
